

exports.__esModule = true;

var _angular = require('angular');

var _uiRouter = require('uiRouter');

var _squid = require('squid');

var _logger = require('xo-beaver/dist/logger');

var _index = require('xo-models/src/checkout/index');

var _util = require('xo-return-to-merchant/dist/util');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _template = require('./template.html');

var _template2 = _interopRequireDefault(_template);

require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var TITLE_KEY_MAPPING = {
    PAYMENT_PROCESS_ERROR: 'paymentProcessError',
    BLOCK_NON_DOMESTIC_SHIPPING: 'blockNonDomesticShippingTitle',
    PAYER_COUNTRY_NOT_ALLOWED: 'payerCountryNotAllowedTitle',
    XOON_PAYER_COUNTRY_NOT_ALLOWED_DCF: 'payerCountryNotAllowedTitleSignupDCF',
    HERMES_PAYER_COUNTRY_NOT_ALLOWED_DCF: 'payerCountryNotAllowedTitleMemberDCF',
    PAYER_COUNTRY_NOT_ENABLED: 'payerCountryNotAllowedTitle',
    PAYER_LOGIN_COUNTRY_NOT_ALLOWED: 'payerCountryNotAllowedTitle',
    TRANSACTION_REFUSED: 'transactionRefusedTitle',
    COMPLIANCE_VIOLATION: 'transactionRefusedTitle',
    DOMESTIC_TRANSACTION_REQUIRED: 'domesticTransactionRequiredTitle',
    INTERNAL_SERVICE_ERROR: 'transactionRefusedTitle',
    NEGATIVE_BALANCE_TRANSACTION_REFUSED: 'negativeBalanceRefusedTitle',
    STUDENT_ACCOUNT: 'studentAccountTitle',
    RETRY: 'sorry'
};

var CONTENT_KEY_MAPPING = {
    INVALID_RESOURCE_ID: 'expiredOrTokenNotFoundError',
    EXPIRED_SESSION: 'expiredOrTokenNotFoundError',
    PAYMENT_ALREADY_DONE: 'paymentAlreadyCompletedError',
    PAYEE_BLOCKED_TRANSACTION: 'paymentDeniedError',
    PAYER_CANNOT_PAY: 'paymentDeniedError',
    RESTRICTED_USER: 'buyerRestrictedError',
    PAYMENT_DENIED: 'paymentDeniedError',
    UNSUPPORTED_PAYEE_CURRENCY: 'unsupportedPayeeCurrency',
    GUEST_UPGRADE_SESSION_ERROR: 'guestUpgradeSessionError',
    GUEST_UPGRADE_ERROR: 'guestUpgradeError',
    BLOCK_NON_DOMESTIC_SHIPPING: 'blockNonDomesticShippingMessage',
    PAYER_COUNTRY_NOT_ALLOWED: 'unauthorizedCountryAccountRegistered',
    XOON_PAYER_COUNTRY_NOT_ALLOWED_DCF: 'unauthorizedCountryAccountSignupDCF',
    HERMES_PAYER_COUNTRY_NOT_ALLOWED_DCF: 'unauthorizedCountryAccountMemberDCF',
    PAYER_COUNTRY_NOT_ENABLED: 'rpUnauthorizedCountryMessage',
    PAYER_LOGIN_COUNTRY_NOT_ALLOWED: 'unauthorizedCountryLogin',
    PAYMENT_PROCESS_ERROR: 'chooseOtherWayToPay',
    GAMING_FUNDING_SOURCE_VALIDATION_FAILED: 'unauthorizedCountryAccountRegistered',
    SENDING_LIMIT_EXCEEDED: 'sendingLimitExceeded',
    TRANSACTION_LIMIT_EXCEEDED: 'transactionLimitExceeded',
    TRANSACTION_REFUSED: 'transactionRefusedMessage',
    COMPLIANCE_VIOLATION: 'complianceViolationMessage',
    DOMESTIC_TRANSACTION_REQUIRED: 'domesticTransactionRequiredMessage',
    INTERNAL_SERVICE_ERROR: 'transactionRefusedMessage',
    DEFAULT: 'genericError',
    NEGATIVE_BALANCE_TRANSACTION_REFUSED: 'negativeBalanceRefusedMessage',
    ACCOUNT_CANNOT_BE_FETCHED: 'genericError',
    STUDENT_ACCOUNT: 'studentAccountMessage',
    RETRY: 'thingsNotWorking',
    DEFAULT_ANDROID_PAY_ERROR: 'androidPayGenericError',
    ANDROID_PAY_ELIGIBILITY_ERROR: 'androidPayGenericError',
    DUPLICATE_INVOICE_ID: 'duplicateInvoiceId',
    UNSUPPORTED_COUNTRY: 'unsupportedCountry',
    ANDROID_PAY_ALREADY_PROVISIONED: 'androidPayAlreadyProvisioned'
};

// pass merchantName attribute, if undefined, then suffix 'Default' to key
var renderContentWithMerchantName = function renderContentWithMerchantName(key) {
    var merchantName = this.props.merchant;

    if (merchantName) {
        return (0, _squid.$renderContent)(key, { merchantName: merchantName });
    }

    return (0, _squid.$renderContent)(key + 'Default');
};

// handle non-standard merchant error title strings
var TITLE_KEY_HANDLER = {
    DOMESTIC_TRANSACTION_REQUIRED: renderContentWithMerchantName,
    XOON_PAYER_COUNTRY_NOT_ALLOWED_DCF: renderContentWithMerchantName,
    HERMES_PAYER_COUNTRY_NOT_ALLOWED_DCF: renderContentWithMerchantName
};

// handle non-standard merchant error content strings
var CONTENT_KEY_HANDLER = {
    DOMESTIC_TRANSACTION_REQUIRED: renderContentWithMerchantName,
    XOON_PAYER_COUNTRY_NOT_ALLOWED_DCF: renderContentWithMerchantName,
    HERMES_PAYER_COUNTRY_NOT_ALLOWED_DCF: renderContentWithMerchantName
};

var HIDE_CANCEL_LINK_CODES = ['PAYER_COUNTRY_NOT_ALLOWED', 'GAMING_FUNDING_SOURCE_VALIDATION_FAILED', 'PAYER_LOGIN_COUNTRY_NOT_ALLOWED'];

var RETRY_LINK = ['RETRY'];

var TRANSACTION_REFUSED_BA_TITLE_MSG = {
    BA_NO_PURCHASE: 'transactionRefusedBAnoPurchaseTitle',
    BA_WITH_PURCHASE: 'transactionRefusedBAPurchaseTitle'
};

/* eslint-disable fasec/no-unsafe-regex */
var base64regex = new RegExp('^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$');

exports['default'] = _squid.$Component.extend('$xoGenericErrorComponent', {

    tag: 'xo-generic-error',
    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            required: false
        },
        isUnbranded: {
            type: 'var',
            required: false
        },
        cancelUrl: {
            type: 'str',
            required: false
        },
        merchant: {
            type: 'str',
            required: false,
            'default': function _default() {
                if (this.models) {
                    var merchant = this.models.checkoutAppData.merchant;
                    return merchant.brand_name || merchant.merchant_name;
                }
            }
        }
    },

    resolve: {
        models: function models() {
            if (this.props.token) {
                return {
                    checkoutAppData: _index.$CheckoutAppDataModel.instance(this.props.token).retrieve()['catch'](angular.noop),
                    cart: _index.$CheckoutCartModel.instance(this.props.token).retrieve()['catch'](angular.noop),
                    checkoutPayee: _index.$CheckoutPayeeModel.instance(this.props.token).retrieve()['catch'](angular.noop)
                };
            }
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            var cancelPreventStateChange = _angular.$rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
                event.preventDefault();
            });

            this.$on('$destroy', cancelPreventStateChange);

            var self = this;

            // to not break other application's error integration, we'll still support base64 decoded code parameters
            if (_uiRouter.$stateParams.code && base64regex.test(_uiRouter.$stateParams.code)) {
                self.errorCode = _squid.$util.base64Decode(_uiRouter.$stateParams.code);
            } else {
                self.errorCode = _uiRouter.$stateParams.code;
            }

            self.hideCancelLink = HIDE_CANCEL_LINK_CODES.indexOf(self.errorCode) > -1;
            self.retryLink = RETRY_LINK.indexOf(self.errorCode) > -1;

            _angular.$rootScope.allowUnload = true;
            self.cancelLink = self.props.cancelUrl;

            self.cancelRedirect = function ($event) {
                $event.preventDefault();
                var redirectUrl = self.cancelLink;

                if (_angular.$rootScope.partnerIntegration) {
                    _logger.$logger.info('genericerror_partner_integration');
                    redirectUrl = _squid.$util.buildURL(self.cancelLink, { error: 'true' });
                }

                _util.$ReturnToMerchant.goTo(redirectUrl);
            };

            self.retryCheckout = function ($event) {
                $event.preventDefault();

                _squid.$util.reload();
            };

            (0, _jquery2['default'])('.paypalHeaderWrapper').hide();
            (0, _jquery2['default'])('#defaultCancelLink').hide();
            (0, _jquery2['default'])('.footerWrapper').addClass('genericError');

            self.$on('$destroy', function (event) {
                (0, _jquery2['default'])('.paypalHeaderWrapper').show();
                (0, _jquery2['default'])('#defaultCancelLink').show();
                (0, _jquery2['default'])('.footerWrapper').removeClass('genericError');
            });

            // Returns the title string, based on custom key handler
            self.getTitle = function () {
                var key = self.titleKey;

                if (TITLE_KEY_HANDLER.hasOwnProperty(self.errorCode)) {
                    return TITLE_KEY_HANDLER[self.errorCode].call(_this, key);
                }

                return (0, _squid.$renderContent)(key);
            };

            // Returns the content string, based on custom key handler
            self.getContent = function () {

                var key = self.contentKey;

                if (CONTENT_KEY_HANDLER.hasOwnProperty(self.errorCode)) {
                    return CONTENT_KEY_HANDLER[self.errorCode].call(_this, key);
                }

                return (0, _squid.$renderContent)(key);
            };

            // Returns the cancel button label, based on presence of brand/merchant name
            self.getCancelLabel = function () {
                if (self.walletTokenization) {
                    if (self.errorCode === 'ANDROID_PAY_ALREADY_PROVISIONED') {
                        return (0, _squid.$renderContent)('common.backToAndroidPayB');
                    } else {
                        return (0, _squid.$renderContent)('common.backToAndroidPay');
                    }
                } else {
                    var merchantName = _this.props.merchant;

                    if (merchantName) {
                        return (0, _squid.$renderContent)('common.returnToMerchant', { merchantName: merchantName });
                    }

                    return (0, _squid.$renderContent)('common.returnToDefaultMerchant');
                }
            };
        },
        populate: function populate() {
            if (this.models.checkoutAppData) {
                this.cancelLink = this.models.checkoutAppData.urls.cancel_url;
            }

            if (this.models.checkoutPayee) {
                var merchant = this.models.checkoutPayee.merchant;

                if (merchant.id && !this.hideCancelLink) {
                    var hcl = _squid.$config.hideCancelLinkForMerchant;

                    var shouldHide = hcl && hcl.indexOf(merchant.id) !== -1;
                    if (shouldHide) {
                        this.hideCancelLink = true;
                    }
                }
            }

            if (this.models.cart) {
                this.walletTokenization = this.models.cart.isWalletTokenization();
            }

            // Map error code for Android Pay
            if (this.walletTokenization) {
                // For Android Pay, map all errors to generic Android Pay error except for
                // ANDROID_PAY_ALREADY_PROVISIONED
                if (this.errorCode !== 'ANDROID_PAY_ALREADY_PROVISIONED') {
                    this.errorCode = 'DEFAULT_ANDROID_PAY_ERROR';
                }
            }

            var titleKey = this.errorCode && TITLE_KEY_MAPPING[this.errorCode];
            if (titleKey) {
                if (titleKey === 'transactionRefusedTitle' && this.models.cart && this.models.cart.isBillingNoPurchase()) {
                    this.titleKey = 'genericError.' + TRANSACTION_REFUSED_BA_TITLE_MSG['BA_NO_PURCHASE'];
                } else if (titleKey === 'transactionRefusedTitle' && this.models.cart && this.models.cart.isBillingPurchase()) {
                    this.titleKey = 'genericError.' + TRANSACTION_REFUSED_BA_TITLE_MSG['BA_WITH_PURCHASE'];
                } else {
                    this.titleKey = 'genericError.' + titleKey;
                }
            }

            var contentKey = this.errorCode && CONTENT_KEY_MAPPING[this.errorCode] || CONTENT_KEY_MAPPING.DEFAULT;
            this.contentKey = 'genericError.' + contentKey;
        }
    }

});


_angular.$rootScope;

_uiRouter.$stateParams;

_squid.$Component;

_squid.$util;

_squid.$renderContent;

_squid.$config;

_logger.$logger;

_index.$CheckoutAppDataModel;

_index.$CheckoutCartModel;

_index.$CheckoutPayeeModel;

_util.$ReturnToMerchant;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./components/xo-ui-components/src/generic-error/directive.js
// module id = ./components/xo-ui-components/src/generic-error/directive.js
// module chunks = 1